export default __webpack_public_path__ + "static/media/img-onboarding-bg-mob.f40aae07.svg";